<template>
    <div>
        <Breadcrumbs main="Admin" submain="Portfolio" title="Awards" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add Award</h7>                             
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="award_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(title)="row">
                                            <div v-if="row.item.title">
                                                <p style="max-width: 270px;">{{ row.item.title }}</p>
                                            </div>
                                        </template>

                                        <template #cell(description)="row">
                                            <div v-if="row.item.description">
                                                <p style="max-width: 380px;">{{ row.item.description }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteAward(data.item.id)" title="Delete"></feather>
                                                </div>
                                                <div @click="editAward(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Awards Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Awards" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Award Type</label>
                            <input class="form-control" type="text" placeholder="Enter Award Type" v-model="award.type">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Title</label>
                            <input class="form-control" type="text" placeholder="Enter Title" v-model="award.title">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Year</label>
                            <input class="form-control" type="text" placeholder="Enter Year" v-model="award.year">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Country</label>
                            <input class="form-control" type="text" placeholder="Enter Country" v-model="award.country">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Description</label>
                            <input class="form-control" type="text" placeholder="Enter Description" v-model="award.description">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Awards Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Awards" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Award Type</label>
                            <input class="form-control" type="text" placeholder="Enter Award Type" v-model="edit_award.type">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Title</label>
                            <input class="form-control" type="text" placeholder="Enter Title" v-model="edit_award.title">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Year</label>
                            <input class="form-control" type="text" placeholder="Enter Year" v-model="edit_award.year">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Country</label>
                            <input class="form-control" type="text" placeholder="Enter Country" v-model="edit_award.country">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Description</label>
                            <input class="form-control" type="text" placeholder="Enter Description" v-model="edit_award.description">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Gallery Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this award?</div>
        </b-modal>
    </div>
</template>
       
<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import Datepicker from 'vuejs-datepicker';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import moment from "moment";
    import { mapState } from 'vuex';
    import loader from '../loader/loader.vue';
    import { VueEditor } from "vue2-editor";
    
    export default {
        components: {
            Datepicker,
            loader,
            VueEditor
        },
    
        data() {
            return {
                editor: ClassicEditor,
    
                tablefields: [
                {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'type',
                        label: 'Award Type',
                        sortable: true
                    },
                    {
                        key: 'title',
                        label: 'Title',
                        sortable: true
                    },
                    {
                        key: 'year',
                        label: 'Year',
                        sortable: true
                    },
                    {
                        key: 'country',
                        label: 'Country',
                        sortable: true
                    },
                    {
                        key: 'description',
                        label: 'Description',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                award: {
                    type: '',
                    year: '',
                    title: '',
                    country: '',
                    description: '',
                },
    
                edit_award: {
                    id: '',
                    type: '',
                    year: '',
                    title: '',
                    country: '',
                    description: ''
                },
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [5, 10, 15]
            };
        },
    
        computed: {
            ...mapState({
                award_list: state => state.award.award,
                loading: state => state.award.awardLoading,
                error: state => state.award.awardError
            }),
    
            sortOptions() {
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("award/fetchAward").then(() => {
                this.items = this.award_list
                this.totalRows = this.items.length;
            });
        },
    
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.award.type = null
                this.award.year = null
                this.award.title = null
                this.award.country = null
                this.award.description = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("award/addAward", {
                    award: this.award
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.award.type = null
                        this.award.year = null
                        this.award.title = null
                        this.award.country = null
                        this.award.description = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editAward(detail) {
                this.edit_award.id = detail.id ? detail.id : null
                this.edit_award.type = detail.type ? detail.type : null
                this.edit_award.year = detail.year ? detail.year : null
                this.edit_award.title = detail.title ? detail.title : null
                this.edit_award.country = detail.country ? detail.country : null
                this.edit_award.description = detail.description ? detail.description : null
            },
    
            resetEditModal() {
                this.edit_award.type = null
                this.edit_award.year = null
                this.edit_award.title = null
                this.edit_award.country = null
                this.edit_award.description = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("award/updateAward", {
                    id: this.edit_award.id,
                    award: this.edit_award,
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.edit_award.type = null
                        this.edit_award.year = null
                        this.edit_award.title = null
                        this.edit_award.country = null
                        this.edit_award.description = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteAward(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("award/deleteAward", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    